import * as Yup from 'yup'
import i18n from '../../i18n'
import { VALIDATION } from '../../utils/translation-constants'

// eslint-disable-next-line import/prefer-default-export
export const CreateTermDepositSchema = Yup.object().shape({
  debitAccNo: Yup.string().required('Debit Account No. is required'),
  creditAccNo: Yup.string().required('Credit Account No. is required'),
  amount: Yup.string().required(i18n.t(VALIDATION.AMOUNT)),
  // tenorPeriod: Yup.string().required(i18n.t(VALIDATION.TENURE)),
  // tenorValue: Yup.string().required('Tenure value is required'),
  interestCredit: Yup.string().required('Interest Payment Method is required'),
  toCurrency: Yup.string().required(i18n.t(VALIDATION.currency)),
})

export const TopUpDepositSchema = Yup.object().shape({
  termAccNo: Yup.string().required('Please Select Deposit Account Number'),
  debitAccNo: Yup.string().required('Please Select Funding Account Number'),
  topupAmount: Yup.string().required(i18n.t(VALIDATION.AMOUNT)),
})

export const RedeemDepositSchema = Yup.object().shape({
  termAccNo: Yup.string().required('Please Select Deposit Account Number'),
})
